<template>
	<div>
		<!-- 病历列表 -->
		<Popup
			v-model="medicalList_display"
			title="查看病历"
			expandBtnText="病历汇总"
			confirmBtnText="新增病历"
			:expandBtnDisplay="true"
			@expandClick="handleSummaryClick"
			@confirmClick="handleAddMedical"
		>
			<div v-loading="medicalList_loading" style="padding: 15px;">
				<!-- 表格 -->
				<div class="base_table">
					<el-table
						:data="medicalList_list"
						style="width: 100%"
					>
						<el-table-column
							prop="formatTime"
							label="时间"
						>
						</el-table-column>
						<el-table-column
							label="操作"
							width="300"
						>
							<template slot-scope="scope">
								<el-button
									@click="handleViewClick(scope.row)"
								>查看</el-button>
								<el-button
									type="danger"
									@click="handleDeleteClick(scope.row)"
								>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 表格 end -->
				
				<!-- 页码 -->
				<div class="clear_both" style="margin-top: 20px;">
					<div class="base_pager" style="float: right;">
						<el-pagination 
							layout="total, prev, pager, next, jumper" 
							next-text="下一页" 
							:total="medicalList_total"
							:current-page="medicalList_page"
							@current-change="handleMedicalListPageChange"
						>
						</el-pagination>
					</div>
				</div>
				<!-- 页码 end-->
			</div>
		</Popup>
		<!-- 病历列表 end-->
		
		<!-- 新增病历 -->
		<Popup
			v-model="addMedical_display"
			title="新增病历"
			@confirmClick="handleAddMedicalConfirm"
		>
			<div v-loading="addMedical_loading" style="padding: 15px;">
				<div class="base_form_row" style="padding: 0;">
					<el-date-picker
						v-model="addMedical_time"
						:editable="false"
						:clearable="false"
						class="b_inp"
						placeholder="病历时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleAddMedicalTimeChange"
					>
					</el-date-picker>
				</div>
				<!-- 基本信息 -->
				<div class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td colspan="6">一、基本信息</td>
						</tr>
						<tr>
							<td width="16.66%">姓名</td>
							<td width="16.66%">{{ userInfo.u_r_name || '' }}</td>
							<td width="16.66%">性别</td>
							<td width="16.66%">{{ userInfo.usex == 0 ? '男' : '女' }}</td>
							<td width="16.66%">年龄</td>
							<td>{{ userInfo.uage || '' }}</td>
						</tr>
						<tr>
							<td>联系方式</td>
							<td colspan="5">{{ userInfo.uphone || '' }}</td>
						</tr>
						<tr>
							<td>主诉/症状/需求</td>
							<td colspan="5"><textarea v-model="addMedical_symptom" type="text" placeholder="主诉/症状/需求" style="height: 48px;" /></td>
						</tr>
						<tr>
							<td>职业或日常生活习惯</td>
							<td colspan="5"><textarea v-model="addMedical_habit" type="text" placeholder="职业或日常生活习惯" style="height: 48px;" /></td>
						</tr>
						<tr>
							<td>既往诊断/治疗/训练史</td>
							<td colspan="5"><textarea v-model="addMedical_trainingHistory" type="text" placeholder="既往诊断/治疗/训练史" style="height: 48px;" /></td>
						</tr>
						<tr>
							<td>家族史</td>
							<td colspan="5"><textarea v-model="addMedical_familyHistory" type="text" placeholder="家族史" style="height: 48px;" /></td>
						</tr>
						<tr>
							<td>备注</td>
							<td colspan="5"><textarea v-model="addMedical_remark" type="text" placeholder="其它检查项目，例如眼球震颤、先天性白内障、先天性上睑下垂、先天性小角膜、眼底视盘发育不良等" style="height: 48px;" /></td>
						</tr>
					</table>
				</div>
				<!-- 基本信息 end -->
				<!-- 检查项目 -->
				<div class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td colspan="5">二、检查项目</td>
						</tr>
						<tr>
							<td></td>
							<td colspan="4">检查结果</td>
						</tr>
						<!-- 屈光检查 -->
						<tr>
							<td>屈光检查</td>
							<td colspan="4" style="padding: 0px;">
								<table>
									<tr>
										<td width="20%">裸眼视力</td>
										<td width="20%">OD</td>
										<td width="20%"><input v-model="addMedical_nakedOD" type="text" placeholder="OD" /></td>
										<td width="20%">OS</td>
										<td width="20%" style="border-right: none;"><input v-model="addMedical_nakedOS" type="text" placeholder="OS" /></td>
									</tr>
									<tr style="border-bottom: none;">
										<td><span style="color: #f00;">*</span>矫正视力</td>
										<td>OD</td>
										<td><input v-model="addMedical_correctOD" type="text" placeholder="OD" /></td>
										<td>OS</td>
										<td style="border-right: none;"><input v-model="addMedical_correctOS" type="text" placeholder="OS" /></td>
									</tr>
								</table>
							</td>
						</tr>
						<!-- 屈光检查 end -->
						<tr>
							<td width="16.66%">眼镜处方</td>
							<td width="20.83%">OD</td>
							<td width="20.83%"><input v-model="addMedical_glassOD" type="text" placeholder="OD" /></td>
							<td width="20%">OS</td>
							<td width="20%"><input v-model="addMedical_glassOS" type="text" placeholder="OS" /></td>
						</tr>
						<!-- 双眼视检查 -->
						<tr>
							<td>双眼视检查</td>
							<td colspan="4" style="padding: 0;">
								<table>
									<tr>
										<td width="20%">Worth-4-dot检查</td>
										<td width="80%" style="border-right: none;"><input v-model="addMedical_worthDot" type="text" placeholder="Worth-4-dot检查" /></td>
									</tr>
									<tr>
										<td>立体视检查</td>
										<td style="border-right: none;"><input v-model="addMedical_stereo" type="text" placeholder="立体视检查" /></td>
									</tr>
									<tr>
										<td>戴镜 NPC</td>
										<td style="border-right: none;"><input v-model="addMedical_npc" type="text" placeholder="戴镜 NPC" /></td>
									</tr>
									<tr>
										<td>遮盖/交替遮盖</td>
										<td style="border-right: none;"><input v-model="addMedical_cover" type="text" placeholder="遮盖/交替遮盖" /></td>
									</tr>
									<tr>
										<td>远距水平眼位</td>
										<td style="border-right: none;"><input v-model="addMedical_farEye" type="text" placeholder="远距水平眼位" /></td>
									</tr>
									<tr>
										<td>近距水平眼位</td>
										<td style="border-right: none;"><input v-model="addMedical_nearEye" type="text" placeholder="近距水平眼位" /></td>
									</tr>
									<tr>
										<td>梯度法AC/A</td>
										<td style="border-right: none;"><input v-model="addMedical_ac" type="text" placeholder="梯度法AC/A" /></td>
									</tr>
									<tr>
										<td>PRA</td>
										<td style="border-right: none;"><input v-model="addMedical_pra" type="text" placeholder="PRA" /></td>
									</tr>
									<tr>
										<td>NRA</td>
										<td style="border-right: none;"><input v-model="addMedical_nra" type="text" placeholder="NRA" /></td>
									</tr>
									<tr>
										<td>调节灵敏度</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="addMedical_sensitivityOD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="addMedical_sensitivityOS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="addMedical_sensitivityOU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<tr>
										<td>融像范围</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr style="border-bottom: none;">
													<td width="15%">F</td>
													<td width="35%" style="padding: 0;">
														<table>
															<tr>
																<td width="40%">BI</td>
																<td width="60%" style="border-right: none;"><input v-model="addMedical_fusionFBI" type="text" placeholder="BI" /></td>
															</tr>
															<tr style="border-bottom: none;">
																<td>BO</td>
																<td style="border-right: none;"><input v-model="addMedical_fusionFBO" type="text" placeholder="BI" /></td>
															</tr>
														</table>
													</td>
													<td width="15%">N</td>
													<td width="35%" style="padding: 0;border-right: none;">
														<table>
															<tr>
																<td width="40%">BI</td>
																<td width="60%" style="border-right: none;"><input v-model="addMedical_fusionNBI" type="text" placeholder="BI" /></td>
															</tr>
															<tr style="border-bottom: none;">
																<td>BO</td>
																<td style="border-right: none;"><input v-model="addMedical_fusionNBO" type="text" placeholder="BI" /></td>
															</tr>
														</table>
													</td>
												</tr>
											</table>
										</td>
									</tr>
									<tr style="border-bottom: none;">
										<td>调节反应</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr style="border-bottom: none;">
													<td width="25%">BCC</td>
													<td width="75%" style="border-right: none;"><input v-model="addMedical_adjustment" type="text" placeholder="BCC" /></td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
						<!-- 双眼视检查 end -->
						<!-- 视知觉功能检查 -->
						<tr>
							<td>视知觉功能检查</td>
							<td colspan="4" style="padding: 0;">
								<table>
									<!-- 光栅锐度 -->
									<tr>
										<td width="20%">光栅锐度</td>
										<td width="80%" style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="addMedical_ga_OD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="addMedical_ga_OS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="addMedical_ga_OU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<!-- 光栅锐度 end -->
									<!-- 纹理感知能力 -->
									<tr>
										<td>纹理感知能力</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="addMedical_SCSF2nd_OD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="addMedical_SCSF2nd_OS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="addMedical_SCSF2nd_OU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<!-- 纹理感知能力 end -->
									<!-- 纹理运动感知能力 -->
									<tr>
										<td>纹理运动感知能力</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="addMedical_MG2nd_OD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="addMedical_MG2nd_OS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="addMedical_MG2nd_OU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<!-- 纹理运动感知能力 end -->
									<!-- 截止频率 -->
									<tr>
										<td>截止频率</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="addMedical_cutoffsf_OD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="addMedical_cutoffsf_OS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="addMedical_cutoffsf_OU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<!-- 截止频率 end -->
									<!-- 光栅运动感知能力 -->
									<tr style="border-bottom: none;">
										<td>光栅运动感知能力</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="addMedical_MG1st_OD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="addMedical_MG1st_OS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="addMedical_MG1st_OU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<!-- 光栅运动感知能力 end -->
								</table>
							</td>
						</tr>
						<!-- 视知觉功能检查 end -->
					</table>
				</div>
				<!-- 检查项目 end -->
				
				<div v-for="(v, i) in addMedical_uploadImgSrc" :key="i" class="base_upload" style="margin-top: 20px;">
					<el-image
						class="b_show_img"
						:src="v"
					>
					</el-image>
					<i class="b_delete" @click="handleAddImgDeleteClick(i)"></i>
				</div>
				
				<div class="base_upload" style="margin-top: 20px;" @click="handleAddFileClick">
					<div class="b_control">
						<img src="../../../../../assets/images/upload_icon.png" alt="">
						<!-- <input type="file" accept="image/*" multiple="true" @change="handleAddFileInputChange"/> -->
					</div>
				</div>
			</div>
		</Popup>
		<!-- 新增病历 -->
		
		<!-- 查看病历 -->
		<Popup
			v-model="medical_display"
			title="查看病历"
			confirmBtnText="修改"
			:width="950"
			@confirmClick="handleUpdateClick"
		>
			<div v-loading="medical_loading" style="min-height: 300px;padding: 15px;">
				<div style="text-align: right;">
					<el-button v-print="viewPrint" type="primary">打印</el-button>
				</div>
				<div style="margin: 20px auto 0;text-align: center;">
					<div id="view_medical" style="display: inline-block;vertical-align: top;"></div>
				</div>
			</div>
		</Popup>
		<!-- 查看病历 end -->
		
		<!-- 修改病历 -->
		<Popup
			v-model="updateMedical_display"
			title="修改病历"
			@confirmClick="handleUpdateMedicalConfirm"
		>
			<div v-loading="updateMedical_loading" style="padding: 15px;">
				<div class="base_form_row" style="padding: 0;">
					<el-date-picker
						v-model="updateMedical_time"
						:editable="false"
						:clearable="false"
						class="b_inp"
						placeholder="修改时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleUpdateMedicalTimeChange"
					>
					</el-date-picker>
				</div>
				<!-- 基本信息 -->
				<div class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td colspan="6">一、基本信息</td>
						</tr>
						<tr>
							<td width="16.66%">姓名</td>
							<td width="16.66%">{{ userInfo.u_r_name || '' }}</td>
							<td width="16.66%">性别</td>
							<td width="16.66%">{{ userInfo.usex == 0 ? '男' : '女' }}</td>
							<td width="16.66%">年龄</td>
							<td>{{ userInfo.uage || '' }}</td>
						</tr>
						<tr>
							<td>联系方式</td>
							<td colspan="5">{{ userInfo.uphone || '' }}</td>
							<!-- <td>地址/学校</td>
							<td colspan="3">{{ userInfo.uaddress || '' }}</td> -->
						</tr>
						<tr>
							<td>主诉/症状/需求</td>
							<td colspan="5"><textarea v-model="updateMedical_symptom" type="text" placeholder="主诉/症状/需求" style="height: 48px;" /></td>
						</tr>
						<tr>
							<td>职业或日常生活习惯</td>
							<td colspan="5"><textarea v-model="updateMedical_habit" type="text" placeholder="职业或日常生活习惯" style="height: 48px;" /></td>
						</tr>
						<tr>
							<td>既往诊断/治疗/训练史</td>
							<td colspan="5"><textarea v-model="updateMedical_trainingHistory" type="text" placeholder="既往诊断/治疗/训练史" style="height: 48px;" /></td>
						</tr>
						<tr>
							<td>家族史</td>
							<td colspan="5"><textarea v-model="updateMedical_familyHistory" type="text" placeholder="家族史" style="height: 48px;" /></td>
						</tr>
						<tr>
							<td>备注</td>
							<td colspan="5"><textarea v-model="updateMedical_remark" type="text" placeholder="其它检查项目，例如眼球震颤、先天性白内障、先天性上睑下垂、先天性小角膜、眼底视盘发育不良等" style="height: 48px;" /></td>
						</tr>
					</table>
				</div>
				<!-- 基本信息 end -->
				<!-- 检查项目 -->
				<div class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td colspan="5">二、检查项目</td>
						</tr>
						<tr>
							<td></td>
							<td colspan="4">检查结果</td>
						</tr>
						<!-- 屈光检查 -->
						<tr>
							<td>屈光检查</td>
							<td colspan="4" style="padding: 0px;">
								<table>
									<tr>
										<td width="20%">裸眼视力</td>
										<td width="20%">OD</td>
										<td width="20%"><input v-model="updateMedical_nakedOD" type="text" placeholder="OD" /></td>
										<td width="20%">OS</td>
										<td width="20%" style="border-right: none;"><input v-model="updateMedical_nakedOS" type="text" placeholder="OS" /></td>
									</tr>
									<tr style="border-bottom: none;">
										<td><span style="color: #f00;">*</span>矫正视力</td>
										<td>OD</td>
										<td><input v-model="updateMedical_correctOD" type="text" placeholder="0.01~2.00/4.00~5.50" /></td>
										<td>OS</td>
										<td style="border-right: none;"><input v-model="updateMedical_correctOS" type="text" placeholder="0.01~2.00/4.00~5.50" /></td>
									</tr>
								</table>
							</td>
						</tr>
						<!-- 屈光检查 end -->
						<tr>
							<td width="16.66%">眼镜处方</td>
							<td width="20.83%">OD</td>
							<td width="20.83%"><input v-model="updateMedical_glassOD" type="text" placeholder="OD" /></td>
							<td width="20%">OS</td>
							<td width="20%"><input v-model="updateMedical_glassOS" type="text" placeholder="OS" /></td>
						</tr>
						<!-- 双眼视检查 -->
						<tr>
							<td>双眼视检查</td>
							<td colspan="4" style="padding: 0;">
								<table>
									<tr>
										<td width="20%">Worth-4-dot检查</td>
										<td width="80%" style="border-right: none;"><input v-model="updateMedical_worthDot" type="text" placeholder="Worth-4-dot检查" /></td>
									</tr>
									<tr>
										<td>立体视检查</td>
										<td style="border-right: none;"><input v-model="updateMedical_stereo" type="text" placeholder="立体视检查" /></td>
									</tr>
									<tr>
										<td>戴镜 NPC</td>
										<td style="border-right: none;"><input v-model="updateMedical_npc" type="text" placeholder="戴镜 NPC" /></td>
									</tr>
									<tr>
										<td>遮盖/交替遮盖</td>
										<td style="border-right: none;"><input v-model="updateMedical_cover" type="text" placeholder="遮盖/交替遮盖" /></td>
									</tr>
									<tr>
										<td>远距水平眼位</td>
										<td style="border-right: none;"><input v-model="updateMedical_farEye" type="text" placeholder="远距水平眼位" /></td>
									</tr>
									<tr>
										<td>近距水平眼位</td>
										<td style="border-right: none;"><input v-model="updateMedical_nearEye" type="text" placeholder="近距水平眼位" /></td>
									</tr>
									<tr>
										<td>梯度法AC/A</td>
										<td style="border-right: none;"><input v-model="updateMedical_ac" type="text" placeholder="梯度法AC/A" /></td>
									</tr>
									<tr>
										<td>PRA</td>
										<td style="border-right: none;"><input v-model="updateMedical_pra" type="text" placeholder="PRA" /></td>
									</tr>
									<tr>
										<td>NRA</td>
										<td style="border-right: none;"><input v-model="updateMedical_nra" type="text" placeholder="NRA" /></td>
									</tr>
									<tr>
										<td>调节灵敏度</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="updateMedical_sensitivityOD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="updateMedical_sensitivityOS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="updateMedical_sensitivityOU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<tr>
										<td>融像范围</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr style="border-bottom: none;">
													<td width="15%">F</td>
													<td width="35%" style="padding: 0;">
														<table>
															<tr>
																<td width="40%">BI</td>
																<td width="60%" style="border-right: none;"><input v-model="updateMedical_fusionFBI" type="text" placeholder="BI" /></td>
															</tr>
															<tr style="border-bottom: none;">
																<td>BO</td>
																<td style="border-right: none;"><input v-model="updateMedical_fusionFBO" type="text" placeholder="BI" /></td>
															</tr>
														</table>
													</td>
													<td width="15%">N</td>
													<td width="35%" style="padding: 0;border-right: none;">
														<table>
															<tr>
																<td width="40%">BI</td>
																<td width="60%" style="border-right: none;"><input v-model="updateMedical_fusionNBI" type="text" placeholder="BI" /></td>
															</tr>
															<tr style="border-bottom: none;">
																<td>BO</td>
																<td style="border-right: none;"><input v-model="updateMedical_fusionNBO" type="text" placeholder="BI" /></td>
															</tr>
														</table>
													</td>
												</tr>
											</table>
										</td>
									</tr>
									<tr style="border-bottom: none;">
										<td>调节反应</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr style="border-bottom: none;">
													<td width="25%">BCC</td>
													<td width="75%" style="border-right: none;"><input v-model="updateMedical_adjustment" type="text" placeholder="BCC" /></td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
						<!-- 双眼视检查 end -->
						<!-- 视知觉功能检查 -->
						<tr>
							<td>视知觉功能检查</td>
							<td colspan="4" style="padding: 0;">
								<table>
									<!-- 光栅锐度 -->
									<tr>
										<td width="20%">光栅锐度</td>
										<td width="80%" style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="updateMedical_ga_OD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="updateMedical_ga_OS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="updateMedical_ga_OU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<!-- 光栅锐度 end -->
									<!-- 纹理感知能力 -->
									<tr>
										<td>纹理感知能力</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="updateMedical_SCSF2nd_OD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="updateMedical_SCSF2nd_OS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="updateMedical_SCSF2nd_OU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<!-- 纹理感知能力 end -->
									<!-- 纹理运动感知能力 -->
									<tr>
										<td>纹理运动感知能力</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="updateMedical_MG2nd_OD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="updateMedical_MG2nd_OS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="updateMedical_MG2nd_OU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<!-- 纹理运动感知能力 end -->
									<!-- 截止频率 -->
									<tr>
										<td>截止频率</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="updateMedical_cutoffsf_OD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="updateMedical_cutoffsf_OS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="updateMedical_cutoffsf_OU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<!-- 截止频率 end -->
									<!-- 光栅运动感知能力 -->
									<tr style="border-bottom: none;">
										<td>光栅运动感知能力</td>
										<td style="padding: 0;border-right: none;">
											<table>
												<tr>
													<td width="25%">OD</td>
													<td width="25%"><input v-model="updateMedical_MG1st_OD" type="text" placeholder="OD" /></td>
													<td width="25%">OS</td>
													<td width="25%" style="border-right: none;"><input v-model="updateMedical_MG1st_OS" type="text" placeholder="OS" /></td>
												</tr>
												<tr style="border-bottom: none;">
													<td>OU</td>
													<td colspan="3" style="border-right: none;"><input v-model="updateMedical_MG1st_OU" type="text" placeholder="OU" /></td>
												</tr>
											</table>
										</td>
									</tr>
									<!-- 光栅运动感知能力 end -->
								</table>
							</td>
						</tr>
						<!-- 视知觉功能检查 end -->
					</table>
				</div>
				<!-- 检查项目 end -->
				
				<div v-for="(v, i) in updateMedical_uploadImgSrc" :key="i" class="base_upload" style="margin-top: 20px;">
					<el-image
						class="b_show_img"
						:src="v"
					>
					</el-image>
					<i class="b_delete" @click="handleUpdateImgDeleteClick(i)"></i>
				</div>
				
				<div class="base_upload" style="margin-top: 20px;">
					<div class="b_control" @click="handleUpdateFileClick">
						<img src="../../../../../assets/images/upload_icon.png" alt="">
						<!-- <input type="file" accept="image/*" multiple="true" @change="handleUpdateFileInputChange"/> -->
					</div>
				</div>
			</div>
		</Popup>
		<!-- 修改病历 end -->
		
		<!-- 病历汇总 -->
		<Popup
			v-model="summary_display"
			title="病历汇总"
			:width="950"
			:confirmBtnDisplay="false"
		>
			<div v-loading="summary_loading" style="min-height: 300px;padding: 15px;">
				<div style="text-align: right;">
					<el-button v-print="summaryPrint" type="primary">打印</el-button>
				</div>
				<div style="margin: 20px auto 0;text-align: center;">
					<div id="summary_medical" style="display: inline-block;vertical-align: top;"></div>
				</div>
			</div>
		</Popup>
		<!-- 病历汇总 -->
		
		<!-- 图片裁剪 -->
		<div v-if="imgCutterDisplay" style="position: absolute;z-index: 99;width: 100%;height: 100%;top: 0;left: 0;">
			<ImgCutter
				:boxWidth="800"
				:boxHeight="600"
				:cutWidth="474"
				:cutHeight="580"
				:sizeChange="true"
				:moveAble="true"

				ref="imgCutterModal"
				@cutDown="imgCutterCutDown"
				@onClearAll="imgCutterClear"
			>
				<span slot="open"></span>
			</ImgCutter>
		</div>
		<!-- 图片裁剪 end -->
		
		<!-- 图片预览 -->
		<transition name="fade_transition">
			<div v-if="viewerDisplay" style="position: absolute;z-index: 99;width: 100%;height: 100%;top: 0;left: 0;">
				<el-image-viewer
					:on-close="closeViewer" 
					:url-list="viewerImgList" 
				/>
			</div>
		</transition>
		<!-- 图片预览 end -->
	</div>
</template>

<script>
	import Api from "../../../../../api/index.js";
	import BaseMethods from '../../../../../assets/js/base.js';
	import { mapState } from 'vuex';
	import MyPrint from '../../../../../assets/js/print.js';
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			formId: {
				type: String,
				required: true
			},
			code: {
				type: String,
				required: true
			}
		},
		mounted () {
			this.medical_id = '';
			this.updateId = '';
			this.display && (this.medicalList_display = true);
		},
		data () {
			return {
				imgCutterDisplay: false,
				imgCutterType: '',
				viewerDisplay: false,
				viewerImgList: [],
				viewPrint: {
					id: "view_medical",
					popTitle: '病历'
				},
				summaryPrint: {
					id: "summary_medical",
					popTitle: '病历'
				},
				
				userInfo: {},
				
				medicalList_display: false,
				medicalList_loading: false,
				medicalList_page: 1,
				medicalList_total: 0,
				medicalList_list: [],
				
				addMedical_display: false,
				addMedical_loading: false,
				addMedical_time: '',
				addMedical_symptom: '',
				addMedical_habit: '',
				addMedical_trainingHistory: '',
				addMedical_familyHistory: '',
				addMedical_remark: '',
				addMedical_nakedOD: '',
				addMedical_nakedOS: '',
				addMedical_correctOD: '',
				addMedical_correctOS: '',
				addMedical_glassOD: '',
				addMedical_glassOS: '',
				addMedical_worthDot: '',
				addMedical_stereo: '',
				addMedical_npc: '',
				addMedical_cover: '',
				addMedical_farEye: '',
				addMedical_nearEye: '',
				addMedical_ac: '',
				addMedical_pra: '',
				addMedical_nra: '',
				addMedical_sensitivityOD: '',
				addMedical_sensitivityOS: '',
				addMedical_sensitivityOU: '',
				addMedical_fusionFBI: '',
				addMedical_fusionFBO: '',
				addMedical_fusionNBI: '',
				addMedical_fusionNBO: '',
				addMedical_adjustment: '',
				addMedical_ga_OD: '',
				addMedical_ga_OS: '',
				addMedical_ga_OU: '',
				addMedical_SCSF2nd_OD: '',
				addMedical_SCSF2nd_OS: '',
				addMedical_SCSF2nd_OU: '',
				addMedical_MG2nd_OD: '',
				addMedical_MG2nd_OS: '',
				addMedical_MG2nd_OU: '',
				addMedical_cutoffsf_OD: '',
				addMedical_cutoffsf_OS: '',
				addMedical_cutoffsf_OU: '',
				addMedical_MG1st_OD: '',
				addMedical_MG1st_OS: '',
				addMedical_MG1st_OU: '',
				addMedical_uploadImgSrc: [],
				
				medical_display: false,
				medical_loading: false,
				medical_dateTime: '',
				medical_info: {
					basic: {},
					check: {},
					document: {}
				},
				medical_uploadImgSrc: [],
				
				updateMedical_display: false,
				updateMedical_loading: false,
				updateMedical_time: '',
				updateMedical_symptom: '',
				updateMedical_habit: '',
				updateMedical_trainingHistory: '',
				updateMedical_familyHistory: '',
				updateMedical_remark: '',
				updateMedical_nakedOD: '',
				updateMedical_nakedOS: '',
				updateMedical_correctOD: '',
				updateMedical_correctOS: '',
				updateMedical_glassOD: '',
				updateMedical_glassOS: '',
				updateMedical_worthDot: '',
				updateMedical_stereo: '',
				updateMedical_npc: '',
				updateMedical_cover: '',
				updateMedical_farEye: '',
				updateMedical_nearEye: '',
				updateMedical_ac: '',
				updateMedical_pra: '',
				updateMedical_nra: '',
				updateMedical_sensitivityOD: '',
				updateMedical_sensitivityOS: '',
				updateMedical_sensitivityOU: '',
				updateMedical_fusionFBI: '',
				updateMedical_fusionFBO: '',
				updateMedical_fusionNBI: '',
				updateMedical_fusionNBO: '',
				updateMedical_adjustment: '',
				updateMedical_ga_OD: '',
				updateMedical_ga_OS: '',
				updateMedical_ga_OU: '',
				updateMedical_SCSF2nd_OD: '',
				updateMedical_SCSF2nd_OS: '',
				updateMedical_SCSF2nd_OU: '',
				updateMedical_MG2nd_OD: '',
				updateMedical_MG2nd_OS: '',
				updateMedical_MG2nd_OU: '',
				updateMedical_cutoffsf_OD: '',
				updateMedical_cutoffsf_OS: '',
				updateMedical_cutoffsf_OU: '',
				updateMedical_MG1st_OD: '',
				updateMedical_MG1st_OS: '',
				updateMedical_MG1st_OU: '',
				updateMedical_uploadImgSrc: [],
				
				summary_display: false,
				summary_loading: false
			}
		},
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			/********************** @病历列表 ***********************/
			// 获取用户信息
			getUserInfo() {
				const that = this;
				that.medicalList_loading = true;
				var requestData = {
					uCode: that.code,
					type: 'w'
				};
				Api.findUserInfo(requestData).then((res) => {
					if (res.data.success) {
						that.userInfo = res.data.data;
						that.getMedicals();
					} else {
						that.medicalList_loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.medicalList_loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取病历列表
			getMedicals() {
				const that = this;
				that.medicalList_loading = true;
				var requestData = {
					limit: 10,
					longerEnterpriseId: that.formId,
					pageNum: that.medicalList_page,
					uCode: that.code
				};
				Api.findUserMedicals(requestData).then((res) => {
					that.medicalList_loading = false;
					if (res.data.success) {
						that.medicalList_total = res.data.data.totalItems;
						that.medicalList_list = [];
						res.data.data.data.forEach((v) => {
							v.formatTime = BaseMethods.formatTime(v.ucreateTs, 'yy-mm-dd hh:mm:ss');
							that.medicalList_list.push(v);
						});
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.medicalList_loading = false;
					that.$message.error(e.message);
				});
			},
			// 切换页码
			handleMedicalListPageChange (page) {
				if (this.medicalList_page != page) {
					this.medicalList_page = page;
					this.getMedicals();
				}
			},
			
			/********************** @新增病历 ***********************/
			// 点击新增病历
			handleAddMedical() {
				this.addMedical_time = BaseMethods.getTime(new Date().getTime(), 'ymd hms');
				this.addMedical_display = true;
			},
			// 选择时间
			handleAddMedicalTimeChange() {
				this.compareTimeCorrect('add');
			},
			// 点击上传图片
			handleAddFileClick() {
				this.imgCutterType = 'add';
				this.imgCutterDisplay = true;
				this.$nextTick(() => {
					this.$refs.imgCutterModal.handleOpen();
				});
			},
			// 上传图片
			uploadImgForAdd(base64) {
				const that = this;
				that.addMedical_loading = true;
				var timeDelegate = new Date().getTime(),
					picName = `${ timeDelegate }.png`,
					requestData = {
						base: base64,
						picName: picName,
						type: 'medicalRecord'
					};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						that.addMedical_uploadImgSrc = [...that.addMedical_uploadImgSrc, res.data.data.imgUrl.split('?')[0]];
						that.addMedical_loading = false;
					} else {
						that.addMedical_loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.addMedical_loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除上传图片
			handleAddImgDeleteClick(index) {
				this.addMedical_uploadImgSrc.splice(index, 1);
			},
			// 点击新增病历确定
			handleAddMedicalConfirm() {
				const that = this;
				if (!that.visionReg.test(that.addMedical_correctOD)) {
					that.$message.error('矫正视力格式错误！');
					return false;
				}
				if (!that.visionReg.test(that.addMedical_correctOS)) {
					that.$message.error('矫正视力格式错误！');
					return false;
				}
				if (that.addMedical_ga_OD && !that.documentReg.test(that.addMedical_ga_OD)) {
					that.$message.error('光栅锐度格式错误！');
					return false;
				}
				if (that.addMedical_ga_OS && !that.documentReg.test(that.addMedical_ga_OS)) {
					that.$message.error('光栅锐度格式错误！');
					return false;
				}
				if (that.addMedical_ga_OU && !that.documentReg.test(that.addMedical_ga_OU)) {
					that.$message.error('光栅锐度格式错误！');
					return false;
				}
				if (that.addMedical_SCSF2nd_OD && !that.documentReg.test(that.addMedical_SCSF2nd_OD)) {
					that.$message.error('纹理感知能力格式错误！');
					return false;
				}
				if (that.addMedical_SCSF2nd_OS && !that.documentReg.test(that.addMedical_SCSF2nd_OS)) {
					that.$message.error('纹理感知能力格式错误！');
					return false;
				}
				if (that.addMedical_SCSF2nd_OU && !that.documentReg.test(that.addMedical_SCSF2nd_OU)) {
					that.$message.error('纹理感知能力格式错误！');
					return false;
				}
				if (that.addMedical_MG2nd_OD && !that.documentReg.test(that.addMedical_MG2nd_OD)) {
					that.$message.error('纹理运动感知能力格式错误！');
					return false;
				}
				if (that.addMedical_MG2nd_OS && !that.documentReg.test(that.addMedical_MG2nd_OS)) {
					that.$message.error('纹理运动感知能力格式错误！');
					return false;
				}
				if (that.addMedical_MG2nd_OU && !that.documentReg.test(that.addMedical_MG2nd_OU)) {
					that.$message.error('纹理运动感知能力格式错误！');
					return false;
				}
				if (that.addMedical_cutoffsf_OD && !that.documentReg.test(that.addMedical_cutoffsf_OD)) {
					that.$message.error('截止频率格式错误！');
					return false;
				}
				if (that.addMedical_cutoffsf_OS && !that.documentReg.test(that.addMedical_cutoffsf_OS)) {
					that.$message.error('截止频率格式错误！');
					return false;
				}
				if (that.addMedical_cutoffsf_OU && !that.documentReg.test(that.addMedical_cutoffsf_OU)) {
					that.$message.error('截止频率格式错误！');
					return false;
				}
				if (that.addMedical_MG1st_OD && !that.documentReg.test(that.addMedical_MG1st_OD)) {
					that.$message.error('光栅运动感知能力格式错误！');
					return false;
				}
				if (that.addMedical_MG1st_OS && !that.documentReg.test(that.addMedical_MG1st_OS)) {
					that.$message.error('光栅运动感知能力格式错误！');
					return false;
				}
				if (that.addMedical_MG1st_OU && !that.documentReg.test(that.addMedical_MG1st_OU)) {
					that.$message.error('光栅运动感知能力格式错误！');
					return false;
				}
				that.addMedical_loading = true;
				var requestData = {
					"checkDocumentAllVo": {
						"centerDayPlanId": 0,
						"fourWeekPlan": null,
						"oneWeekPlan": null,
						"threeWeekPlan": null,
						"twoWeekPlan": null,
						"u_AC_A": that.addMedical_ac,
						"u_w4dot": that.addMedical_worthDot,
						"uaccomOd": that.addMedical_sensitivityOD,
						"uaccomOs": that.addMedical_sensitivityOS,
						"uaccomOu": that.addMedical_sensitivityOU,
						"uadvise": null,
						"ucareer": that.addMedical_habit,
						"ucenterPeriod": null,
						"ucheckVisionTime": null,
						"ucode": that.userInfo.ucode,
						"ucreate": that.authInfo.uid,
						"ucreateTs": null,
						"udr": 0,
						"uenterpriseId": that.userInfo.uenterpriseId,
						"ufarPos": that.addMedical_farEye,
						"ufoodPlan": null,
						"uglassPlan": null,
						"uheredity": that.addMedical_familyHistory,
						"uid": null,
						"uleftCva": that.addMedical_correctOS,
						"uleftNeva": that.addMedical_nakedOS,
						"umemo": that.addMedical_remark,
						"uname": that.userInfo.u_r_name,
						"unearPos": that.addMedical_nearEye,
						"unpc": that.addMedical_npc,
						"unra": that.addMedical_nra,
						"uoverspread": that.addMedical_cover,
						"uoverspreadPlan": null,
						"upackagePeriod": null,
						"upd": null,
						"uplan": null,
						"upra": that.addMedical_pra,
						"urightCva": that.addMedical_correctOD,
						"urightNeva": that.addMedical_nakedOD,
						"usoftwarePeriod": null,
						"ustereopsis": that.addMedical_stereo,
						"usymptom": that.addMedical_symptom,
						"utrainDayNum": null,
						"utreatmentCourse": null,
						"utreatmentHistory": that.addMedical_trainingHistory,
						"uuserId": that.userInfo.uid,
						"uglassesOdPlan": that.addMedical_glassOD,
						"uglassesOsPlan": that.addMedical_glassOS,
						"ufusionRangeFbi": that.addMedical_fusionFBI,
						"ufusionRangeFbo": that.addMedical_fusionFBO,
						"ufusionRangeNbi": that.addMedical_fusionNBI,
						"ufusionRangeNbo": that.addMedical_fusionNBO,
						"ubcc": that.addMedical_adjustment
					},
					"checkDocumentIndexVo": {
						"cutoffsf": null,
						"cutoffsfOd": that.addMedical_cutoffsf_OD,
						"cutoffsfOs": that.addMedical_cutoffsf_OS,
						"cutoffsfOu": that.addMedical_cutoffsf_OU,
						"ga": null,
						"gaOd": that.addMedical_ga_OD,
						"gaOs": that.addMedical_ga_OS,
						"gaOu": that.addMedical_ga_OU,
						"id": null,
						"mg1st": null,
						"mg1stOd": that.addMedical_MG1st_OD,
						"mg1stOs": that.addMedical_MG1st_OS,
						"mg1stOu": that.addMedical_MG1st_OU,
						"mg2nd": null,
						"mg2ndOd": that.addMedical_MG2nd_OD,
						"mg2ndOs": that.addMedical_MG2nd_OS,
						"mg2ndOu": that.addMedical_MG2nd_OU,
						"scsf2nd": null,
						"scsf2ndOd": that.addMedical_SCSF2nd_OD,
						"scsf2ndOs": that.addMedical_SCSF2nd_OS,
						"scsf2ndOu": that.addMedical_SCSF2nd_OU
					},
					"creater": that.authInfo.uid,
					"id": null,
					"pictureUrls": that.addMedical_uploadImgSrc.join(','),
					"time": that.addMedical_time,
					"uid": that.userInfo.uid,
					"usource": 1
				};
				Api.newMedical(requestData).then((res) => {
					that.addMedical_loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.addMedical_display = false;
						that.getMedicals();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.addMedical_loading = false;
					that.$message.error(e.message);
				});
			},
			
			/********************** @查看病历 ***********************/
			// 点击查看
			handleViewClick(data) {
				const that = this;
				that.medical_id = data.uid;
				that.medical_dateTime = data.formatTime;
				that.medical_display = true;
				that.$nextTick(() => {
					that.viewMedical();
				});
			},
			// 查看病历
			viewMedical() {
				const that = this;
				that.medical_loading = true;
				var requestData = {
					uId: that.medical_id
				};
				Api.viewMedical(requestData).then((res) => {
					that.medical_loading = false;
					if (res.data.success) {
						that.medical_info.basic = res.data.data.basicInforVo;
						that.medical_info.check = res.data.data.checkProjectVo;
						that.medical_info.document = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo : {};
						if (res.data.data.umedicalRecordVoList && res.data.data.umedicalRecordVoList.length) {
							res.data.data.umedicalRecordVoList.forEach(v => {
								that.medical_uploadImgSrc.push(v.pictureUrl);
							});
						}
						that.initViewPrintContent();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.medical_loading = false;
					that.$message.error(e.message);
				});
			},
			
			/********************** @修改病历 ***********************/
			// 点击修改
			handleUpdateClick() {
				this.updateMedical_time = this.medical_dateTime;
				this.medical_display = false;
				this.updateMedical_display = true;
				this.getMedical();
			},
			// 选择时间
			handleUpdateMedicalTimeChange() {
				this.compareTimeCorrect('update');
			},
			// 获取病历
			getMedical() {
				const that = this;
				that.updateMedical_loading = true;
				var requestData = {
					uId: that.medical_id
				};
				Api.viewMedical(requestData).then((res) => {
					that.updateMedical_loading = false;
					if (res.data.success) {
						that.updateId = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.id : '';
						
						that.updateMedical_symptom = res.data.data.basicInforVo.symptom || '';
						that.updateMedical_habit = res.data.data.basicInforVo.career || '';
						that.updateMedical_trainingHistory = res.data.data.basicInforVo.treatmentHistory || '';
						that.updateMedical_familyHistory = res.data.data.basicInforVo.heredity || '';
						that.updateMedical_remark = res.data.data.checkProjectVo.umemo || '';
						
						that.updateMedical_nakedOD = res.data.data.checkProjectVo.urightNeva || '';
						that.updateMedical_nakedOS = res.data.data.checkProjectVo.uleftNeva || '';
						that.updateMedical_correctOD = res.data.data.checkProjectVo.urightCva || '';
						that.updateMedical_correctOS = res.data.data.checkProjectVo.uleftCva || '';
						that.updateMedical_glassOD = res.data.data.checkProjectVo.uglassesOdPlan || '';
						that.updateMedical_glassOS = res.data.data.checkProjectVo.uglassesOsPlan || '';
						that.updateMedical_worthDot = res.data.data.checkProjectVo.w4dot || '';
						that.updateMedical_stereo = res.data.data.checkProjectVo.stereopsis || '';
						that.updateMedical_npc = res.data.data.checkProjectVo.npc || '';
						that.updateMedical_cover = res.data.data.checkProjectVo.overspread || '';
						that.updateMedical_farEye = res.data.data.checkProjectVo.farPos || '';
						that.updateMedical_nearEye = res.data.data.checkProjectVo.nearPos || '';
						that.updateMedical_ac = res.data.data.checkProjectVo.aca || '';
						that.updateMedical_pra = res.data.data.checkProjectVo.pra || '';
						that.updateMedical_nra = res.data.data.checkProjectVo.nra || '';
						that.updateMedical_sensitivityOD = res.data.data.checkProjectVo.accomOD || '';
						that.updateMedical_sensitivityOS = res.data.data.checkProjectVo.accomOS || '';
						that.updateMedical_sensitivityOU = res.data.data.checkProjectVo.accomOU || '';
						that.updateMedical_fusionFBI = res.data.data.checkProjectVo.ufusionRangeFbi || '';
						that.updateMedical_fusionFBO = res.data.data.checkProjectVo.ufusionRangeFbo || '';
						that.updateMedical_fusionNBI = res.data.data.checkProjectVo.ufusionRangeNbi || '';
						that.updateMedical_fusionNBO = res.data.data.checkProjectVo.ufusionRangeNbo || '';
						that.updateMedical_adjustment = res.data.data.checkProjectVo.ubcc || '';
						that.updateMedical_ga_OD = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.gaOd : '';
						that.updateMedical_ga_OS = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.gaOs : '';
						that.updateMedical_ga_OU = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.gaOu : '';
						that.updateMedical_SCSF2nd_OD = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.scsf2ndOd : '';
						that.updateMedical_SCSF2nd_OS = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.scsf2ndOs : '';
						that.updateMedical_SCSF2nd_OU = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.scsf2ndOu : '';
						that.updateMedical_MG2nd_OD = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.mg2ndOd : '';
						that.updateMedical_MG2nd_OS = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.mg2ndOs : '';
						that.updateMedical_MG2nd_OU = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.mg2ndOu : '';
						that.updateMedical_cutoffsf_OD = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.cutoffsfOd : '';
						that.updateMedical_cutoffsf_OS = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.cutoffsfOs : '';
						that.updateMedical_cutoffsf_OU = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.cutoffsfOu : '';
						that.updateMedical_MG1st_OD = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.mg1stOd : '';
						that.updateMedical_MG1st_OS = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.mg1stOs : '';
						that.updateMedical_MG1st_OU = res.data.data.checkDocumentIndexVo ? res.data.data.checkDocumentIndexVo.mg1stOu : '';
						
						if (res.data.data.umedicalRecordVoList && res.data.data.umedicalRecordVoList.length) {
							res.data.data.umedicalRecordVoList.forEach(v => {
								that.updateMedical_uploadImgSrc.push(v.pictureUrl);
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.updateMedical_loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击上传图片
			handleUpdateFileClick() {
				this.imgCutterType = 'update';
				this.imgCutterDisplay = true;
				this.$nextTick(() => {
					this.$refs.imgCutterModal.handleOpen();
				});
			},
			// 上传图片
			uploadImgForUpdate(base64) {
				const that = this;
				that.updateMedical_loading = true;
				var timeDelegate = new Date().getTime(),
					picName = `${ timeDelegate }.png`,
					requestData = {
						base: base64,
						picName: picName,
						type: 'medicalRecord'
					};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						that.updateMedical_uploadImgSrc = [...that.updateMedical_uploadImgSrc, res.data.data.imgUrl.split('?')[0]];
						that.updateMedical_loading = false;
					} else {
						that.updateMedical_loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.updateMedical_loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除上传图片
			handleUpdateImgDeleteClick(index) {
				this.updateMedical_uploadImgSrc.splice(index, 1);
			},
			// 点击修改病历确定
			handleUpdateMedicalConfirm() {
				const that = this;
				if (!that.visionReg.test(that.updateMedical_correctOD)) {
					that.$message.error('矫正视力格式错误！');
					return false;
				}
				if (!that.visionReg.test(that.updateMedical_correctOS)) {
					that.$message.error('矫正视力格式错误！');
					return false;
				}
				if (that.updateMedical_ga_OD && !that.documentReg.test(that.updateMedical_ga_OD)) {
					that.$message.error('光栅锐度格式错误！');
					return false;
				}
				if (that.updateMedical_ga_OS && !that.documentReg.test(that.updateMedical_ga_OS)) {
					that.$message.error('光栅锐度格式错误！');
					return false;
				}
				if (that.updateMedical_ga_OU && !that.documentReg.test(that.updateMedical_ga_OU)) {
					that.$message.error('光栅锐度格式错误！');
					return false;
				}
				if (that.updateMedical_SCSF2nd_OD && !that.documentReg.test(that.updateMedical_SCSF2nd_OD)) {
					that.$message.error('纹理感知能力格式错误！');
					return false;
				}
				if (that.updateMedical_SCSF2nd_OS && !that.documentReg.test(that.updateMedical_SCSF2nd_OS)) {
					that.$message.error('纹理感知能力格式错误！');
					return false;
				}
				if (that.updateMedical_SCSF2nd_OU && !that.documentReg.test(that.updateMedical_SCSF2nd_OU)) {
					that.$message.error('纹理感知能力格式错误！');
					return false;
				}
				if (that.updateMedical_MG2nd_OD && !that.documentReg.test(that.updateMedical_MG2nd_OD)) {
					that.$message.error('纹理运动感知能力格式错误！');
					return false;
				}
				if (that.updateMedical_MG2nd_OS && !that.documentReg.test(that.updateMedical_MG2nd_OS)) {
					that.$message.error('纹理运动感知能力格式错误！');
					return false;
				}
				if (that.updateMedical_MG2nd_OU && !that.documentReg.test(that.updateMedical_MG2nd_OU)) {
					that.$message.error('纹理运动感知能力格式错误！');
					return false;
				}
				if (that.updateMedical_cutoffsf_OD && !that.documentReg.test(that.updateMedical_cutoffsf_OD)) {
					that.$message.error('截止频率格式错误！');
					return false;
				}
				if (that.updateMedical_cutoffsf_OS && !that.documentReg.test(that.updateMedical_cutoffsf_OS)) {
					that.$message.error('截止频率格式错误！');
					return false;
				}
				if (that.updateMedical_cutoffsf_OU && !that.documentReg.test(that.updateMedical_cutoffsf_OU)) {
					that.$message.error('截止频率格式错误！');
					return false;
				}
				if (that.updateMedical_MG1st_OD && !that.documentReg.test(that.updateMedical_MG1st_OD)) {
					that.$message.error('光栅运动感知能力格式错误！');
					return false;
				}
				if (that.updateMedical_MG1st_OS && !that.documentReg.test(that.updateMedical_MG1st_OS)) {
					that.$message.error('光栅运动感知能力格式错误！');
					return false;
				}
				if (that.updateMedical_MG1st_OU && !that.documentReg.test(that.updateMedical_MG1st_OU)) {
					that.$message.error('光栅运动感知能力格式错误！');
					return false;
				}
				that.updateMedical_loading = true;
				var requestData = {
					"checkDocumentAllVo": {
						"centerDayPlanId": 0,
						"fourWeekPlan": null,
						"oneWeekPlan": null,
						"threeWeekPlan": null,
						"twoWeekPlan": null,
						"u_AC_A": that.updateMedical_ac,
						"u_w4dot": that.updateMedical_worthDot,
						"uaccomOd": that.updateMedical_sensitivityOD,
						"uaccomOs": that.updateMedical_sensitivityOS,
						"uaccomOu": that.updateMedical_sensitivityOU,
						"uadvise": null,
						"ucareer": that.updateMedical_habit,
						"ucenterPeriod": null,
						"ucheckVisionTime": null,
						"ucode": that.userInfo.ucode,
						"ucreate": that.authInfo.uid,
						"ucreateTs": null,
						"udr": 0,
						"uenterpriseId": that.userInfo.uenterpriseId,
						"ufarPos": that.updateMedical_farEye,
						"ufoodPlan": null,
						"uglassPlan": null,
						"uheredity": that.updateMedical_familyHistory,
						"uid": that.medical_id,
						"uleftCva": that.updateMedical_correctOS,
						"uleftNeva": that.updateMedical_nakedOS,
						"umemo": that.updateMedical_remark,
						"uname": that.userInfo.u_r_name,
						"unearPos": that.updateMedical_nearEye,
						"unpc": that.updateMedical_npc,
						"unra": that.updateMedical_nra,
						"uoverspread": that.updateMedical_cover,
						"uoverspreadPlan": null,
						"upackagePeriod": null,
						"upd": null,
						"uplan": null,
						"upra": that.updateMedical_pra,
						"urightCva": that.updateMedical_correctOD,
						"urightNeva": that.updateMedical_nakedOD,
						"usoftwarePeriod": null,
						"ustereopsis": that.updateMedical_stereo,
						"usymptom": that.updateMedical_symptom,
						"utrainDayNum": null,
						"utreatmentCourse": null,
						"utreatmentHistory": that.updateMedical_trainingHistory,
						"uuserId": that.userInfo.uid,
						"uglassesOdPlan": that.updateMedical_glassOD,
						"uglassesOsPlan": that.updateMedical_glassOS,
						"ufusionRangeFbi": that.updateMedical_fusionFBI,
						"ufusionRangeFbo": that.updateMedical_fusionFBO,
						"ufusionRangeNbi": that.updateMedical_fusionNBI,
						"ufusionRangeNbo": that.updateMedical_fusionNBO,
						"ubcc": that.updateMedical_adjustment
					},
					"checkDocumentIndexVo": {
						"cutoffsf": null,
						"cutoffsfOd": that.updateMedical_cutoffsf_OD,
						"cutoffsfOs": that.updateMedical_cutoffsf_OS,
						"cutoffsfOu": that.cutoffsf_OU,
						"ga": null,
						"gaOd": that.updateMedical_ga_OD,
						"gaOs": that.updateMedical_ga_OS,
						"gaOu": that.updateMedical_ga_OU,
						"id": that.updateId,
						"mg1st": null,
						"mg1stOd": that.updateMedical_MG1st_OD,
						"mg1stOs": that.updateMedical_MG1st_OS,
						"mg1stOu": that.updateMedical_MG1st_OU,
						"mg2nd": null,
						"mg2ndOd": that.updateMedical_MG2nd_OD,
						"mg2ndOs": that.updateMedical_MG2nd_OS,
						"mg2ndOu": that.updateMedical_MG2nd_OU,
						"scsf2nd": null,
						"scsf2ndOd": that.updateMedical_SCSF2nd_OD,
						"scsf2ndOs": that.updateMedical_SCSF2nd_OS,
						"scsf2ndOu": that.updateMedical_SCSF2nd_OU
					},
					"creater": that.authInfo.uid,
					"id": null,
					"pictureUrls": that.updateMedical_uploadImgSrc.join(','),
					"time": that.updateMedical_time,
					"uid": that.userInfo.uid,
					"usource": 1
				};
				Api.updateMedical(requestData).then((res) => {
					that.updateMedical_loading = false;
					if (res.data.success) {
						that.updateMedical_display = false;
						that.getMedicals();
						that.$message.success(res.data.message);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.updateMedical_loading = false;
					that.$message.error(e.message);
				});
			},
			
			/********************* @summary *************************/
			// 点击病历汇总
			handleSummaryClick() {
				const that = this;
				that.summary_display = true;
				that.$nextTick(() => {
					that.getSummaryData();
				});
			},
			// 获取汇总数据
			getSummaryData() {
				const that = this;
				that.summary_loading = true;
				var requestData = {
					uCode: that.code
				};
				Api.findUserMedicalRecord(requestData).then((res) => {
					that.summary_loading = false;
					if (res.data.success) {
						that.initSummaryPrintContent(res.data.data || []);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.summary_loading = false;
					that.$message.error(e.message);
				});
			},
			
			/********************* @summary *************************/
			// 删除病历
			handleDeleteClick(data) {
				const that = this;
				that.$confirm(
					'确定要删除该病历吗?', 
					'提示', 
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.medicalList_loading = true;
						var requestData = {
							id: data.uid
						};
						Api.deleteMedical(requestData).then((res) => {
							that.medicalList_loading = false;
							if (res.data.success) {
								that.$message.success(res.data.message);
								that.getMedicals();
							} else {
								that.$message.error(res.data.message);
							}
						}, (e) => {
							that.medicalList_loading = false;
							that.$message.error(e.message);
						});
					});
			},
			
			/********************* @Function *************************/
			// 初始化查看病历打印内容
			initViewPrintContent() {
				const that = this;
				let myPrint = new MyPrint({
					container: document.getElementById('view_medical'),
					table: {
						tag: 'table',
						className: 'base_doc',
						attrs: [{
							name: 'border',
							value: '0'
						}, {
							name: 'cellpadding',
							value: '0'
						}, {
							name: 'cellspacing',
							value: '0'
						}]
					}
				});
				myPrint.addRow({
					tag: 'div',
					className: 'clear_both',
					htmlStr: `<p style='float: left;min-height: 24px;line-height: 24px'>病历日期：${ this.medical_dateTime }</p>`
				});
				myPrint.addRow({
					tag: 'tr',
					className: 'b_tt',
					htmlStr: `<td colspan="6">一、基本信息</td>`,
					tableRequired: true
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>姓名</td>
							<td width='16.66%'>${ this.medical_info.basic.name || '' }</td>
							<td width='16.66%'>性别</td>
							<td width='16.66%'>${ this.medical_info.basic.sex == 0 ? '男' : '' }${ this.medical_info.basic.sex == 1 ? '女' : '' }</td>
							<td width='16.66%'>年龄</td>
							<td>${ this.medical_info.basic.age || '' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>联系方式</td>
							<td colspan='5'>${ this.medical_info.basic.phone || '' }</td>`
				});
				this.medical_info.basic.symptom && myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>主诉/症状/需求</td>
							<td colspan='5'>${ this.medical_info.basic.symptom || '/' }</td>`
				});
				this.medical_info.basic.career && myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>职业或日常生活习惯</td>
							<td colspan='5'>${ this.medical_info.basic.career || '/' }</td>`
				});
				this.medical_info.basic.treatmentHistory && myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>既往诊断/治疗/训练史</td>
							<td colspan='5'>${ this.medical_info.basic.treatmentHistory || '/' }</td>`
				});
				this.medical_info.basic.heredity && myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>家族史</td>
							<td colspan='5'>${ this.medical_info.basic.heredity || '/' }</td>`
				});
				this.medical_info.basic.heredity && myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>家族史</td>
							<td colspan='5'>${ this.medical_info.basic.heredity || '/' }</td>`
				});
				this.medical_info.check.umemo && myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>备注</td>
							<td colspan='5'>${ this.medical_info.check.umemo || '/' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					className: 'b_tt',
					htmlStr: `<td colspan='5'>二、检查项目</td>`,
					tableRequired: true,
					tableRemove: true
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'></td>
							<td colspan='4'>检查结果</td>`
				});
				// 屈光检查
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<tr>
						<td width='16.66%'>屈光检查</td>
						<td colspan='4' style="padding: 0px;">
							<table>
								<tr>
									<td width="20%">裸眼视力</td>
									<td width="20%">OD</td>
									<td width="20%">${ this.medical_info.check.urightNeva || '/' }</td>
									<td width="20%">OS</td>
									<td width="20%" style="border-right: none;">${ this.medical_info.check.uleftNeva || '/' }</td>
								</tr>
								<tr style="border-bottom: none;">
									<td><span style="color: #f00;">*</span>矫正视力</td>
									<td>OD</td>
									<td>${ this.medical_info.check.urightCva || '/' }</td>
									<td>OS</td>
									<td style="border-right: none;">${ this.medical_info.check.uleftCva || '/' }</td>
								</tr>
							</table>
						</td>
					</tr>`
				});
				(this.medical_info.check.uglassesOdPlan || this.medical_info.check.uglassesOsPlan)
				&& myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>眼镜处方</td>
						<td width='20.83%'>OD</td>
						<td width='20.83%'>${ this.medical_info.check.uglassesOdPlan || '/' }</td>
						<td width='20.83%'>OS</td>
						<td>${ this.medical_info.check.uglassesOsPlan || '/' }</td>`
				});
				// 双眼视检查
				let binVision_htmlStr = '';
				binVision_htmlStr = `
					<td width='16.66%'>双眼视检查</td>
					<td colspan='4' style='padding: 0;'>
						<table>
							${ this.medical_info.check.w4dot 
							? ("<tr><td width='20%'>Worth-4-dot检查</td><td width='80%' style='border-right: none;'>" + (this.medical_info.check.w4dot || '/') + "</td></tr>")
							: '' }
							${ this.medical_info.check.stereopsis
							? ("<tr><td width='20%'>立体视检查</td><td width='80%' style='border-right: none;'>" + (this.medical_info.check.stereopsis || '/') + "</td></tr>")
							: '' }
							${ this.medical_info.check.npc
							? ("<tr><td width='20%'>戴镜 NPC</td><td width='80%' style='border-right: none;'>" + (this.medical_info.check.npc || '/') + "</td></tr>")
							: '' }
							${ this.medical_info.check.overspread
							? ("<tr><td width='20%'>遮盖/交替遮盖</td><td width='80%' style='border-right: none;'>" + (this.medical_info.check.overspread || '/') + "</td></tr>")
							: '' }
							${ this.medical_info.check.farPos
							? ("<tr><td width='20%'>远距水平眼位</td><td width='80%' style='border-right: none;'>" + (this.medical_info.check.farPos || '/') + "</td></tr>")
							: '' }
							${ this.medical_info.check.nearPos
							? ("<tr><td width='20%'>近距水平眼位</td><td width='80%' style='border-right: none;'>" + (this.medical_info.check.nearPos || '/') + "</td></tr>")
							: '' }
							${ this.medical_info.check.aca
							? ("<tr><td width='20%'>梯度法AC/A</td><td width='80%' style='border-right: none;'>" + (this.medical_info.check.aca || '/') + "</td></tr>")
							: '' }
							${ this.medical_info.check.pra
							? ("<tr><td width='20%'>PRA</td><td width='80%' style='border-right: none;'>" + (this.medical_info.check.pra || '/') + "</td></tr>")
							: '' }
							${ this.medical_info.check.nra
							? ("<tr><td width='20%'>NRA</td><td width='80%' style='border-right: none;'>" + (this.medical_info.check.nra || '/') + "</td></tr>")
							: '' }
							${ (this.medical_info.check.accomOD || this.medical_info.check.accomOS || this.medical_info.check.accomOU)
							? ("<tr><td width='20%'>调节灵敏度</td><td width='80%' style='padding: 0;border-right: none;'><table><tr><td width='25%'>OD</td><td width='25%'>" + (this.medical_info.check.accomOD || '/') + "</td><td width='25%'>OS</td><td width='25%' style='border-right: none;'>" + (this.medical_info.check.accomOS || '/') + "</td></tr><tr style='border-bottom: none;'><td>OU</td><td colspan='3' style='border-right: none;'>" + (this.medical_info.check.accomOU || '/') + "</td></tr></table></td></tr>")
							: '' }
							${ (this.medical_info.check.ufusionRangeFbi || this.medical_info.check.ufusionRangeFbo || this.medical_info.check.ufusionRangeNbi || this.medical_info.check.ufusionRangeNbo)
							? ("<tr><td width='20%'>融像范围</td><td width='80%' style='padding: 0;border-right: none;'><table><tr style='border-bottom: none;'><td width='15%'>F</td><td width='35%' style='padding: 0;'><table><tr><td width='40%'>BI</td><td width='60%' style='border-right: none;'>" + (this.medical_info.check.ufusionRangeFbi || '/') + "</td></tr><tr style='border-bottom: none;'><td>BO</td><td style='border-right: none;'>" + (this.medical_info.check.ufusionRangeFbo || '/') + "</td></tr></table></td><td width='15%'>N</td><td width='35%' style='padding: 0;border-right: none;'><table><tr><td width='40%'>BI</td><td width='60%' style='border-right: none;'>" + (this.medical_info.check.ufusionRangeNbi || '/') + "</td></tr><tr style='border-bottom: none;'><td>BO</td><td style='border-right: none;'>" + (this.medical_info.check.ufusionRangeNbo || '/') + "</td></tr></table></td></tr></table></td></tr>")
							: '' }
							${ this.medical_info.check.ubcc
							? ("<tr style='border-bottom: none;'><td width='20%'>调节反应</td><td width='80%' style='padding: 0;border-right: none;'><table><tr style='border-bottom: none;'><td width='25%'>BCC</td><td width='75%' style='border-right: none;'>" + (this.medical_info.check.ubcc || '/') + "</td></tr></table></td></tr>")
							: '' }
						</table>
					</td>`;
				myPrint.addRow({
					tag: 'tr',
					htmlStr: binVision_htmlStr
				});
				if (this.medical_info.document.gaOd || this.medical_info.document.gaOs || this.medical_info.document.gaOu || this.medical_info.document.scsf2ndOd || this.medical_info.document.scsf2ndOs || this.medical_info.document.scsf2ndOu || this.medical_info.document.mg2ndOd || this.medical_info.document.mg2ndOs || this.medical_info.document.mg2ndOu || this.medical_info.document.cutoffsfOd || this.medical_info.document.cutoffsfOs || this.medical_info.document.cutoffsfOu || this.medical_info.document.mg1stOd || this.medical_info.document.mg1stOs || this.medical_info.document.mg1stOu) {
					// 视知觉功能检查
					let visual_htmlStr = `
						<td width='16.66%'>视知觉功能检查</td>
						<td colspan='4' style='padding: 0;'>
							<table>
								${ (this.medical_info.document.gaOd || this.medical_info.document.gaOs || this.medical_info.document.gaOu)
								? ("<tr><td width='20%'>光栅锐度</td><td width='80%' style='padding: 0;border-right: none;'><table><tr><td width='25%'>OD</td><td width='25%'>" + (this.medical_info.document.gaOd || '/') + "</td><td width='25%'>OS</td><td width='25%' style='border-right: none;'>" + (this.medical_info.document.gaOs || '/') + "</td></tr><tr style='border-bottom: none;'><td>OU</td><td colspan='3' style='border-right: none;'>" + (this.medical_info.document.gaOu || '/') + "</td></tr></table></td></tr>")
								: '' }
								${ (this.medical_info.document.scsf2ndOd || this.medical_info.document.scsf2ndOs || this.medical_info.document.scsf2ndOu)
								? ("<tr><td width='20%'>纹理感知能力</td><td width='80%' style='padding: 0;border-right: none;'><table><tr><td width='25%'>OD</td><td width='25%'>" + (this.medical_info.document.scsf2ndOd || '/') + "</td><td width='25%'>OS</td><td width='25%' style='border-right: none;'>" + (this.medical_info.document.scsf2ndOs || '/') + "</td></tr><tr style='border-bottom: none;'><td>OU</td><td colspan='3' style='border-right: none;'>" + (this.medical_info.document.scsf2ndOu || '/') + "</td></tr></table></td></tr>")
								: '' }
								${ (this.medical_info.document.mg2ndOd || this.medical_info.document.mg2ndOs || this.medical_info.document.mg2ndOu)
								? ("<tr><td width='20%'>纹理运动感知能力</td><td width='80%' style='padding: 0;border-right: none;'><table><tr><td width='25%'>OD</td><td width='25%'>" + (this.medical_info.document.mg2ndOd || '/') + "</td><td width='25%'>OS</td><td width='25%' style='border-right: none;'>" + (this.medical_info.document.mg2ndOs || '/') + "</td></tr><tr style='border-bottom: none;'><td>OU</td><td colspan='3' style='border-right: none;'>" + (this.medical_info.document.mg2ndOu || '/') + "</td></tr></table></td></tr>")
								: '' }
								${ (this.medical_info.document.cutoffsfOd || this.medical_info.document.cutoffsfOs || this.medical_info.document.cutoffsfOu)
								? ("<tr><td width='20%'>截止频率</td><td width='80%' style='padding: 0;border-right: none;'><table><tr><td width='25%'>OD</td><td width='25%'>" + (this.medical_info.document.cutoffsfOd || '/') + "</td><td width='25%'>OS</td><td width='25%' style='border-right: none;'>" + (this.medical_info.document.cutoffsfOs || '/') + "</td></tr><tr style='border-bottom: none;'><td>OU</td><td colspan='3' style='border-right: none;'>" + (this.medical_info.document.cutoffsfOu || '/') + "</td></tr></table></td></tr>")
								: '' }
								${ (this.medical_info.document.mg1stOd || this.medical_info.document.mg1stOs || this.medical_info.document.mg1stOu)
								? ("<tr style='border-bottom: none;'><td width='20%'>光栅运动感知能力</td><td width='80%' style='padding: 0;border-right: none;'><table><tr><td width='25%'>OD</td><td width='25%'>" + (this.medical_info.document.mg1stOd || '/') + "</td><td width='25%'>OS</td><td width='25%' style='border-right: none;'>" + (this.medical_info.document.mg1stOs || '/') + "</td></tr><tr style='border-bottom: none;'><td>OU</td><td colspan='3' style='border-right: none;'>" + (this.medical_info.document.mg1stOu || '/') + "</td></tr></table></td></tr>")
								: '' }
							</table>
						</td>`;
					myPrint.addRow({
						tag: 'tr',
						htmlStr: visual_htmlStr
					});
				}
				let uploadNum = 0;
				this.medical_uploadImgSrc.forEach(v => {
					let _imgEle = new Image();
					_imgEle.src = v;
					_imgEle.onload = () => {
						uploadNum++;
						if (uploadNum >= that.medical_uploadImgSrc.length)
							_();
					}
					_imgEle.onerror = () => {
						uploadNum++;
						if (uploadNum >= that.medical_uploadImgSrc.length)
							_();
					}
				});
				
				function _() {
					let _imgEles = [],
						_view = document.getElementById('view_medical');
						
					that.medical_uploadImgSrc.forEach(v => {
						myPrint.addRow({
							tag: 'div',
							className: 'base_upload',
							style: 'margin-top: 20px;',
							attrs: [{
								name: 'v-vuer',
								value: '{movable: false}'
							}],
							htmlStr: `<img class='b_show_img' src=${ v } />`,
							tableRemove: true
						});
					});
					_imgEles = _view.getElementsByClassName('b_show_img');
					_imgEles.forEach(v => {
						v.onclick = () => {
							that.viewerImgList = [v.src];
							that.viewerDisplay = true;
						}
					});
				}
			},
			// 初始化汇总病历打印内容
			initSummaryPrintContent(list) {
				let myPrint = new MyPrint({
					container: document.getElementById('summary_medical'),
					isRotate: true,
					tableHead: `<tr style='background: #f5f5f5;'>
							<td rowspan='3' width='3.3%' style='padding: 0;'>检查日期</td>
							<td rowspan='1' colspan='2' width='6.6%' style='padding: 0;'>裸眼视力</td>
							<td rowspan='1' colspan='2' width='6.6%' style='padding: 0;'>矫正视力</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>瞳距(mm)</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>Worth-4-dot检查</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>立体视检查</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>戴镜 NPC</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>遮盖/交替遮盖</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>远距水平眼位</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>近距水平眼位</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>梯度法AC/A</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>PRA</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>NRA</td>
							<td rowspan='1' colspan='3' width='9.9%' style='padding: 0;'>调节灵敏度</td>
							<td rowspan='1' colspan='2' width='6.6%' style='padding: 0;'>眼镜处方</td>
							<td rowspan='1' colspan='4' width='14.2%' style='padding: 0;'>融像范围</td>
							<td rowspan='1' width='3.3%' style='padding: 0;'>调节反应</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>光栅锐度</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>纹理感知能力</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>纹理运动感知能力</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>截止频率</td>
							<td rowspan='3' width='3.3%' style='padding: 0;'>光栅运动感知能力</td>
						</tr>
						<tr style='background: #f5f5f5;'>
							<td rowspan='2' style='padding: 0;'>OD</td>
							<td rowspan='2'  style='padding: 0;'>OS</td>
							<td rowspan='2' style='padding: 0;'>OD</td>
							<td rowspan='2' style='padding: 0;'>OS</td>
							<td rowspan='2' style='padding: 0;'>OD</td>
							<td rowspan='2' style='padding: 0;'>OS</td>
							<td rowspan='2' style='padding: 0;'>OU</td>
							<td rowspan='2' style='padding: 0;'>OD</td>
							<td rowspan='2' style='padding: 0;'>OS</td>
							<td rowspan='1' colspan='2' style='padding: 0;'>F</td>
							<td rowspan='1' colspan='2' style='padding: 0;'>N</td>
							<td rowspan='2' style='padding: 0;'>BCC</td>
						</tr>
						<tr style='background: #f5f5f5;'>
							<td rowspan='1' style='padding: 0;'>BI</td>
							<td rowspan='1' style='padding: 0;'>BO</td>
							<td rowspan='1' style='padding: 0;'>BI</td>
							<td rowspan='1' style='padding: 0;'>BO</td>
						</tr>`,
					table: {
						tag: 'table',
						className: 'base_doc',
						style: 'font-size: 11px;line-height: 18px;',
						attrs: [{
							name: 'border',
							value: '0'
						}, {
							name: 'cellpadding',
							value: '0'
						}, {
							name: 'cellspacing',
							value: '0'
						}]
					}
				});
				myPrint.addRow({
					tag: 'div',
					className: 'clear_both',
					htmlStr: `<p style='float: left;text-align: left;'>姓名:${ this.userInfo.u_r_name }&nbsp;&nbsp;&nbsp;&nbsp;账号:${ this.userInfo.ucode }</p>
								<p style='float: right;text-align: right;'>打印日期：${ BaseMethods.getTime(new Date().getTime(), 'ymd hms') }</p>`
				});
				
				// 添加表格
				list.forEach((v, i) => {
					if (i == 0) {
						_addTableRow(v, true);
					} else {
						_addTableRow(v);
					}
				});
				
				// 添加间距
				myPrint.addRow({
					tag: 'div',
					style: 'height: 20px;',
					tableRemove: true
				});
				
				// 添加上传图片
				const that = this;
				let uploadNum = 0;
				let uploadImgLen = 0;
				let uploadSrc = [];
				list.forEach(v => {
					v.umedicalRecordVoList && v.umedicalRecordVoList.forEach(item => {
						uploadSrc.push({
							date: BaseMethods.formatTime(item.createTime, 'yy-mm-dd hh:mm:ss'),
							src: item.pictureUrl
						});
						uploadImgLen++;
					});
				});

				uploadSrc.forEach(v => {
					let _imgEle = new Image();
					_imgEle.src = v.src;
					_imgEle.onload = () => {
						uploadNum++;
						if (uploadNum >= uploadImgLen)
							_addUpload();
					}
					_imgEle.onerror = () => {
						uploadNum++;
						if (uploadNum >= uploadImgLen)
							_addUpload();
					}
				});
				
				// 添加上传图片
				function _addUpload() {
					let _imgEles = [];
					let _view = document.getElementById('summary_medical');
					let _htmlStr = '';
					let _htmlArr = [];
					uploadSrc.forEach((v, i) => {
						let _dom = `<div style='position: relative;float: left;width: 50%;height: 100%;padding: 39px 15px 15px;border: 1px solid #ccc;'>
								<p style='position: absolute;width: 100%;top: 15px;left: 0;padding: 0 15px;'>${ v.date }</p>
								<div style='position: relative;width: 100%;height: 100%;overflow: hidden;'>
									<img class='a4_show_img' src=${ v.src } style='display: block;position: absolute;max-width: 100%;top: 50%;left: 50%;cursor: pointer;transform: translate(-50%, -50%);' />
								</div>
							</div>`;
						if (i % 2 != 0) {
							_htmlStr += _dom;
							_htmlArr.push(_htmlStr);
						} else {
							_htmlStr = _dom;
							i >= uploadSrc.length - 1 && (_htmlArr.push(_htmlStr));
						}
					});
					_htmlArr.forEach(v => {
						myPrint.addRow({
							tag: 'div',
							style: `height: ${ Math.floor(MyPrint.A4Height / 2 - MyPrint.verticalPadding - 1) }px;`,
							tableRemove: true,
							htmlStr: v
						});
					});
					_imgEles = _view.getElementsByClassName('a4_show_img');
					_imgEles.forEach(v => {
						v.onclick = () => {
							that.viewerImgList = [v.src];
							that.viewerDisplay = true;
						}
					});
				}

				// 添加每一行
				function _addTableRow(option, tableRequired) {
					let _row = {
						tag: 'tr',
						hasTableHead: true,
						htmlStr: `<td width='3.3%' style='padding: 0;'>${ BaseMethods.formatTime(option.ucreateTs) }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.urightNeva || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.uleftNeva || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.urightCva || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.uleftCva || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.pd || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.w4dot || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.stereopsis || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.npc || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.overspread || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.farPos || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.nearPos || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.aca || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.pra || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.nra || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.accomOd || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.accomOs || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.accomOu || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.uglassesOdPlan || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.uglassesOsPlan || '/' }</td>
								<td width='3.55%' style='padding: 0;'>${ option.checkProjectVo.ufusionRangeFbi || '/' }</td>
								<td width='3.55%' style='padding: 0;'>${ option.checkProjectVo.ufusionRangeFbo || '/' }</td>
								<td width='3.55%' style='padding: 0;'>${ option.checkProjectVo.ufusionRangeNbi || '/' }</td>
								<td width='3.55%' style='padding: 0;'>${ option.checkProjectVo.ufusionRangeNbo || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ option.checkProjectVo.ubcc || '/' }</td>
								<td width='3.3%' style='padding: 0;'>${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.gaOd) ? option.checkDocumentIndexVo.gaOd : '' }/${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.gaOs) ? option.checkDocumentIndexVo.gaOs : '' }/${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.gaOu) ? option.checkDocumentIndexVo.gaOu : '' }</td>
								<td width='3.3%' style='padding: 0;'>${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.scsf2ndOd) ? option.checkDocumentIndexVo.scsf2ndOd : '' }/${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.scsf2ndOs) ? option.checkDocumentIndexVo.scsf2ndOs : '' }/${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.scsf2ndOu) ? option.checkDocumentIndexVo.scsf2ndOu : '' }</td>
								<td width='3.3%' style='padding: 0;'>${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.mg2ndOd) ? option.checkDocumentIndexVo.mg2ndOd : '' }/${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.mg2ndOs) ? option.checkDocumentIndexVo.mg2ndOs : '' }/${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.mg2ndOu) ? option.checkDocumentIndexVo.mg2ndOu : '' }</td>
								<td width='3.3%' style='padding: 0;'>${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.cutoffsfOd) ? option.checkDocumentIndexVo.cutoffsfOd : '' }/${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.cutoffsfOs) ? option.checkDocumentIndexVo.cutoffsfOs : '' }/${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.cutoffsfOu) ? option.checkDocumentIndexVo.cutoffsfOu : '' }</td>
								<td width='3.3%' style='padding: 0;'>${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.mg1stOd) ? option.checkDocumentIndexVo.mg1stOd : '' }/${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.mg1stOs) ? option.checkDocumentIndexVo.mg1stOs : '' }/${ (option.checkDocumentIndexVo && option.checkDocumentIndexVo.mg1stOu) ? option.checkDocumentIndexVo.mg1stOu : '' }</td>`
					};
					tableRequired && (_row.tableRequired = true); 
					myPrint.addRow(_row);
				}
			},
			// 完成截图后要执行的方法
			imgCutterCutDown(file) {
				let base64 = file.dataURL;
				this.imgCutterType == 'add' && this.uploadImgForAdd(base64);
				this.imgCutterType == 'update' && this.uploadImgForUpdate(base64);
			},
			// 清空画布
			imgCutterClear() {
				this.imgCutterDisplay = false;
			},
			// 关闭预览图片
			closeViewer() {
				this.viewerDisplay = false;
			},
			// 创建横屏打印css
			createLandscape() {
				let cssDom = document.createElement('style');
				cssDom.id = 'landscape_print';
				// cssDom.media= 'print';
				cssDom.innerHTML = '@page{ margin: 0;size: landscape; }@media print{ @page{ size: landscape;margin: 0; } }';
				document.getElementsByTagName('head')[0].appendChild(cssDom);
			},
			// 移除横屏打印css
			removeLandscape() {
				let cssDom = document.getElementById('landscape_print');
				cssDom && document.getElementsByTagName('head')[0].removeChild(cssDom);
			},
			// 时间选择判断
			compareTimeCorrect(type) {
				var destTime = new Date(type == 'add' ? this.addMedical_time : this.updateMedical_time).getTime(),
					nowTime = new Date().getTime();
				if (destTime > nowTime) {
					type == 'add'
					? (this.addMedical_time = BaseMethods.getTime(new Date().getTime(), 'ymd hms'))
					: (this.updateMedical_time = this.medical_dateTime);
					this.$message({
						message: '选择时间不能大于当前时间！！！',
						type: 'warning'
					});
				}
			}
		},
		components: {
			ElImageViewer
		},
		watch: {
			display (newVal) {
				this.medicalList_display = newVal;
			},
			medicalList_display (newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.imgCutterDisplay = false;
					this.imgCutterType = '';
					this.viewerDisplay = false;
					this.viewerImgList = [];
					this.userInfo = {};
					this.medical_id = '';
					this.medical_dateTime = '';
					this.updateId = '';
					
					this.medicalList_loading = false;
					this.medicalList_page = 1;
					this.medicalList_total = 0;
					this.medicalList_list = [];
					
					this.addMedical_display = false;
					this.addMedical_loading = false;
					
					this.updateMedical_display = false;
					this.updateMedical_loading = false;
					this.getUserInfo();
				}
			},
			addMedical_display(newVal) {
				if (!newVal) {
					this.addMedical_display = false;
					this.addMedical_loading = false;
					this.addMedical_time = '';
					this.addMedical_symptom = '';
					this.addMedical_habit = '';
					this.addMedical_trainingHistory = '';
					this.addMedical_familyHistory = '';
					this.addMedical_remark = '';
					this.addMedical_nakedOD = '';
					this.addMedical_nakedOS = '';
					this.addMedical_correctOD = '';
					this.addMedical_correctOS = '';
					this.addMedical_glassOD = '';
					this.addMedical_glassOS = '';
					this.addMedical_worthDot = '';
					this.addMedical_stereo = '';
					this.addMedical_npc = '';
					this.addMedical_cover = '';
					this.addMedical_farEye = '';
					this.addMedical_nearEye = '';
					this.addMedical_ac = '';
					this.addMedical_pra = '';
					this.addMedical_nra = '';
					this.addMedical_sensitivityOD = '';
					this.addMedical_sensitivityOS = '';
					this.addMedical_sensitivityOU = '';
					this.addMedical_fusionFBI = '';
					this.addMedical_fusionFBO = '';
					this.addMedical_fusionNBI = '';
					this.addMedical_fusionNBO = '';
					this.addMedical_adjustment = '';
					this.addMedical_ga_OD = '';
					this.addMedical_ga_OS = '';
					this.addMedical_ga_OU = '';
					this.addMedical_SCSF2nd_OD = '';
					this.addMedical_SCSF2nd_OS = '';
					this.addMedical_SCSF2nd_OU = '';
					this.addMedical_MG2nd_OD = '';
					this.addMedical_MG2nd_OS = '';
					this.addMedical_MG2nd_OU = '';
					this.addMedical_cutoffsf_OD = '';
					this.addMedical_cutoffsf_OS = '';
					this.addMedical_cutoffsf_OU = '';
					this.addMedical_MG1st_OD = '';
					this.addMedical_MG1st_OS = '';
					this.addMedical_MG1st_OU = '';
					this.addMedical_uploadImgSrc = [];
				}
			},
			medical_display(newVal) {
				if (!newVal) {
					this.medical_loading = false;
					this.medical_info = {
						basic: {},
						check: {},
						document: {}
					};
					this.medical_uploadImgSrc = [];
				}
			},
			updateMedical_display(newVal) {
				if (!newVal) {
					this.updateMedical_loading = false;
					this.updateMedical_time = '';
					this.updateMedical_symptom = '';
					this.updateMedical_habit = '';
					this.updateMedical_trainingHistory = '';
					this.updateMedical_familyHistory = '';
					this.updateMedical_remark = '';
					this.updateMedical_nakedOD = '';
					this.updateMedical_nakedOS = '';
					this.updateMedical_correctOD = '';
					this.updateMedical_correctOS = '';
					this.updateMedical_glassOD = '';
					this.updateMedical_glassOS = '';
					this.updateMedical_worthDot = '';
					this.updateMedical_stereo = '';
					this.updateMedical_npc = '';
					this.updateMedical_cover = '';
					this.updateMedical_farEye = '';
					this.updateMedical_nearEye = '';
					this.updateMedical_ac = '';
					this.updateMedical_pra = '';
					this.updateMedical_nra = '';
					this.updateMedical_sensitivityOD = '';
					this.updateMedical_sensitivityOS = '';
					this.updateMedical_sensitivityOU = '';
					this.updateMedical_fusionFBI = '';
					this.updateMedical_fusionFBO = '';
					this.updateMedical_fusionNBI = '';
					this.updateMedical_fusionNBO = '';
					this.updateMedical_adjustment = '';
					this.updateMedical_ga_OD = '';
					this.updateMedical_ga_OS = '';
					this.updateMedical_ga_OU = '';
					this.updateMedical_SCSF2nd_OD = '';
					this.updateMedical_SCSF2nd_OS = '';
					this.updateMedical_SCSF2nd_OU = '';
					this.updateMedical_MG2nd_OD = '';
					this.updateMedical_MG2nd_OS = '';
					this.updateMedical_MG2nd_OU = '';
					this.updateMedical_cutoffsf_OD = '';
					this.updateMedical_cutoffsf_OS = '';
					this.updateMedical_cutoffsf_OU = '';
					this.updateMedical_MG1st_OD = '';
					this.updateMedical_MG1st_OS = '';
					this.updateMedical_MG1st_OU = '';
					this.updateMedical_uploadImgSrc = [];
				}
			},
			summary_display(newVal) {
				if (!newVal) {
					this.summary_loading = false;
					this.removeLandscape();
				} else {
					this.createLandscape();
				}
			}
		}
	}
</script>

<style>
</style>
